import { Component, ViewChild, ElementRef } from "@angular/core";
import { ICellRendererParams, CellValueChangedEvent, IsColumnFunc } from "ag-grid";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { IsColumnFuncParams } from "ag-grid/dist/lib/entities/colDef";


@Component({
  selector: 'ag-del-button',
  template: `<button type="button" class="btn btn-small btn-red ag-del-btn" (click)="onClick()">삭제</button>`,
})
export class AgDeleteButtonComponent implements ICellRendererAngularComp {

  params: ICellRendererParams;
  constructor() { }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh() {
    return false;
  }

  onClick() {
    this.params.context.componentParent.deleteFromParent(this.params);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/ag-grid/renderer/ag-del-button.ts